import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class InventoryOutSheet extends Component{
    constructor(){
        super();
        this.save = this.save.bind(this)
        this.handleQuantity = this.handleQuantity.bind(this)
        this.state={
            userId : "",
            user : {},
            outSheet :{}
        }
        
    }

    componentDidMount(){
        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });

        var inventory = ref.child("Inventory").child("Sheets").child(this.props.match.params.id)
            inventory.on("value", function(snap){
                this.setState({
                    outSheet : snap.val()
                })
            }.bind(this))    
    }

    handleQuantity(e){
        if(e.target.value > this.state.outSheet.count){
            alert("Out of Range")
            e.target.value = this.state.outSheet.count
        }
    }
    save(e){
        e.preventDefault();
        var newCount = parseInt(this.state.outSheet.count,10) - parseInt(this.quantity.value,10)
        //console.log(newCount)
        let update ={
            
            count : newCount
        }
        let stockOut={
            status: "Out",
            thickness : this.thickness.value,
            dimension : this.dimension.value,
            length : this.length.value,
            color : this.color.value,
            count : this.quantity.value,
            remarks : this.remarks.value,
            date : Date()
            
        }
        ref.child("Inventory").child("Sheets").child(this.props.match.params.id).update(update).then(alert("Sheets has been deducted"))
        ref.child("StockCard").child("Sheets").push(stockOut)
    }
    

    
          
    render() {

        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title=" Inventory Out Sheets" />
                            <div className="block">

                                <form className="form-horizontal form-bordered" ref={input => this.formSubmit = input} onSubmit={this.save}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Dimension</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.dimension=input}} type="text" value={this.state.outSheet.dimension} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Length</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.length=input}} type="text" value={this.state.outSheet.length} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Thickness</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.thickness=input}} type="text" value={this.state.outSheet.thickness} />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Color</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.color=input}} type="text" value={this.state.outSheet.color}/>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Enter Quantity</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.quantity=input}} type="number" min="1" max ={this.state.outSheet.count} onChange={this.handleQuantity}/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Remarks</label>
                                        <div className="col-md-4">
                                            <textarea className="form-control" rows="3" ref={(input) =>{this.remarks=input}} ></textarea>
                                        </div>
                                    </div>
                                        
                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Save</button>
                                        </div>
                                    </div>
                                </form>               
                            </div>                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  InventoryOutSheet;



// WEBPACK FOOTER //
// ./src/components/InventoryOutSheet.js